/**
 * Ho-SYS AI — API client
 */
import { getMemToken } from "@/api/api";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const url = `${API_URL}${path}`;
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
  const t = getMemToken();
  if (t) headers["Authorization"] = `Bearer ${t}`;
  const res = await fetch(url, { ...opts, credentials: "include", headers });
  if (!res.ok) {
    let detail = "Error";
    try {
      const j = await res.json();
      detail = j.detail || JSON.stringify(j);
    } catch (e) { /* noop */ }
    throw new Error(detail);
  }
  return res.json();
}

function qs(params) {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    usp.append(k, v);
  });
  const s = usp.toString();
  return s ? `?${s}` : "";
}

export const hosysAiApi = {
  meta: () => req(`/api/hosysai/meta`),
  dashboard: (venue_id) => req(`/api/hosysai/dashboard${qs({ venue_id })}`),

  getDiagnostic: (venue_id) => req(`/api/hosysai/diagnostic${qs({ venue_id })}`),
  saveDiagnostic: (data) =>
    req(`/api/hosysai/diagnostic`, { method: "POST", body: JSON.stringify(data) }),

  listSystems: (venue_id) => req(`/api/hosysai/systems${qs({ venue_id })}`),
  getSystem: (id) => req(`/api/hosysai/systems/${id}`),
  createSystem: (data) => req(`/api/hosysai/systems`, { method: "POST", body: JSON.stringify(data) }),
  updateSystem: (id, data) => req(`/api/hosysai/systems/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  deleteSystem: (id) => req(`/api/hosysai/systems/${id}`, { method: "DELETE" }),

  listIncidents: (venue_id, status) => req(`/api/hosysai/incidents${qs({ venue_id, status })}`),
  createIncident: (data) => req(`/api/hosysai/incidents`, { method: "POST", body: JSON.stringify(data) }),
  updateIncident: (id, data) => req(`/api/hosysai/incidents/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  deleteIncident: (id) => req(`/api/hosysai/incidents/${id}`, { method: "DELETE" }),
};

export default hosysAiApi;
